import { useQuery } from '@tanstack/react-query'

import { getAccountConnectionStatus } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { useGetUserCookieJwt } from '@src/hooks/queries/login/mutations/use-get-user-cookie-jwt'

export const useFetchAccountConnectionStatus = () => {
  const { axiosInstance } = useAxios({
    apiType: 'CREDIT_API',
    shouldSkipLogout: true,
  })
  const { mutateAsync: getUserCookie } = useGetUserCookieJwt()

  return useQuery({
    queryFn: async () => {
      const token = await getUserCookie()
      axiosInstance.defaults.headers.common['authorization'] =
        `Bearer ${token.data.token}`
      return getAccountConnectionStatus(axiosInstance)
    },
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_CREDIT_ACCOUNT_CONNECTION_STATUS],
  })
}
